import React from "react";
import Dashboard from "components/dashboard";
import ActionButtons from "./list-page";
import SourcesPaginatedTable from "./table";
import { PageHeaderBar, PageSection } from "components/page";
import { SearchForm } from "./list-page";
import { useFormState } from "components/common";
import { parsePage } from "components/table";
import { parseQueryParams, handleChangeSearchFormField, handleClearSearchForm } from "components/common";

const SourceListPage = ({ location: { search }, history }) => {
  const [state, dispatch] = useFormState({
    startDate: null,
    endDate: null,
    deploymentId: "",
    ...parseQueryParams(search),
  });

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.source.list" buttons={<ActionButtons />} />
      <PageSection spaced>
        <SearchForm
          onChange={handleChangeSearchFormField({ dispatch, search, history })}
          searchState={state}
          onClear={handleClearSearchForm({ dispatch, history })}
        />
      </PageSection>
      <PageSection spaced hideBackground>
        <SourcesPaginatedTable showDeployment page={parsePage({ queryParams: search })} variables={state} />
      </PageSection>
    </Dashboard>
  );
};

export default SourceListPage;
